import { Component, Input, OnInit } from '@angular/core';
import { VersionHistoryChangesPanelComponent } from '@components/version-history-changes-panel/version-history-changes-panel.component';
import { COLOR_OPTIONS } from 'icreate/common/models/version-change-panel';

@Component({
    selector: 'app-version-approver-panel',
    templateUrl: './version-approver-panel.component.html',
    styleUrls: [
        './version-approver-panel.component.css',
        '../version-history-changes-panel/version-history-changes-panel.component.css',
    ],
    standalone: false,
})
export class VersionApproverPanelComponent extends VersionHistoryChangesPanelComponent implements OnInit {
    @Input() changes: { approved: string[]; rejected: { reason: string; by: string }[] };
    @Input() version: string;

    ngOnInit(): void {
        if (this.changes) {
            for (let i = 0; i < this.changes.approved?.length; i++) {
                if (i + this.changes.approved.length < COLOR_OPTIONS.length) {
                    this.colors[this.changes.approved[i]] = COLOR_OPTIONS[i];
                } else {
                    this.colors[this.changes.approved[i]] = COLOR_OPTIONS[i - COLOR_OPTIONS.length + 1];
                }
            }
            for (let i = 0; i < this.changes.rejected?.length; i++) {
                if (i + this.changes.approved.length < COLOR_OPTIONS.length) {
                    this.colors[this.changes.rejected[i].by] = COLOR_OPTIONS[i + this.changes.approved.length];
                } else {
                    this.colors[this.changes.rejected[i].by] = COLOR_OPTIONS[i - COLOR_OPTIONS.length + 1];
                }
            }
        }
    }
}
